import { FormInput, GridContainer, mixins, styled } from '@bob/library'

export const Wrapper = styled(GridContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  ${mixins.media.min.tablet} {
    min-width: 600px;
  }
`

export const SearchInput = styled(FormInput)`
  ${mixins.media.min.tablet} {
    width: 100%;
  }
`
